import Timer from '../helpers/Timer';

// the NTP algorithm
// t0 is the client's timestamp of the request packet transmission,
// t1 is the server's timestamp of the request packet reception,
// t2 is the server's timestamp of the response packet transmission and
// t3 is the client's timestamp of the response packet reception.
function ntp(t0, t1, t2, t3) {
    return {
        roundtripdelay: (t3 - t0) - (t2 - t1),
        offset: ((t1 - t0) + (t2 - t3)) / 2
    };
}

function initTimer() {

    $('.auction-timer').each(function() {
        Timer.init($(this), Timer.getTimestamp($(this).attr('data-end')));
    });

}

$(document).ready(function() {
    // window.timeDiff = window.s_time - Date.parse(new Date());

    var t0 = (new Date()).valueOf();
    $.ajax({
        url: '/api/updater/time',
        type: 'post',
        dataType: 'json',
        success: function(servertime, text, resp) {
            var t1 = servertime.start,
                t2 = servertime.now,
                t3 = (new Date()).valueOf();

            var date = resp.getResponseHeader("Date");
            if (date) {
                t2 = (new Date(date)).valueOf();
            }

            var c = ntp(t0, t1, t2, t3);
            var d = new Date();
            window.timeShift = (d.getTimezoneOffset() * 60 + servertime.shift) * 1000;

            // log the calculated value rtt and time driff so we can manually verify if they make sense
            window.timeDiff = c.offset;

            initTimer();
        }
    });
});